import { User } from '../../../entity/User'
import { LAST_INTERACTED_SURVEY_TIME } from '../../../types/survey'

export function shouldFetchSurvey() {
    const authUser = new User()
    const lastInteractedSurveyTimeRaw = localStorage.getItem(
        `${authUser.login}${LAST_INTERACTED_SURVEY_TIME}`
    ) ?? 'null'
    const lastInteractedSurveyTime = JSON.parse(lastInteractedSurveyTimeRaw)

    if (lastInteractedSurveyTime === null || lastInteractedSurveyTime === 'null') {
        return true
    }

    const elapsedTime = Date.now() - parseInt(lastInteractedSurveyTime, 10)
    const twentyFourHours = 24 * 60 * 60 * 1000

    return elapsedTime >= twentyFourHours
}